export const mapQuotePayload = (data) => ({
  customerId: data.customerId || null,
  partId: data.partId || null,
  partName: data.partName,
  partNumber: data.partNumber,
  weight: data.weight ? Number(data.weight) : null,
  leadId: data.leadId || null,
  locationId: data.locationId ? Number(data.locationId) : null,
  treeId: data.treeId ? Number(data.treeId) : null,
  moldType: Number(data.moldType) || 0,
  partsPerTree: Number(data.partsPerTree) || 1,
  materialId: data.materialId || null,
  handDipping: !!data.handDipping,
  handBlasting: Number(data.handBlasting) || 0,
  gates: Number(data.gates) || 1,
  flushWitness: data.flushWitness ? Number(data.flushWitness) : null,
  flashing: !!data.flashing,
  hardToFixture: !!data.hardToFixture,
  weldRepair: !!data.weldRepair,
  fineDetail: !!data.fineDetail,
  straightening: !!data.straightening,
  price: data.price ? Number(data.price) : null,
  notes: data.notes,
});

export const mapQuoteDefaults = (quote) => {
  if (!quote) return { partsPerTree: 1, moldType: 0, handBlasting: 0, gates: 1 };
  return {
    customerId: quote.customer?.id || quote.customerId,
    partId: quote.part?.id || quote.partId,
    partName: quote.partName,
    partNumber: quote.partNumber,
    weight: quote.weight,
    locationId: quote.location?.id || quote.locationId,
    treeId: quote.tree?.id || quote.treeId,
    moldType: quote.moldType,
    partsPerTree: quote.partsPerTree,
    materialId: quote.material?.id || quote.materialId,
    handDipping: quote.handDipping,
    handBlasting: quote.handBlasting,
    gates: quote.gates,
    flushWitness: quote.flushWitness,
    flashing: quote.flashing,
    hardToFixture: quote.hardToFixture,
    weldRepair: quote.weldRepair,
    fineDetail: quote.fineDetail,
    straightening: quote.straightening,
    price: quote.price,
    notes: quote.notes,
  };
};
